import React from 'react'
import PropTypes from 'prop-types'
import SectionHeader from './section-header'

function FieldSizeSection(props) {
  const { fieldSizes, selectedSize, currency, step } = props
  const currencyName = currency == 'usd' ? '' : ` (${currency.toUpperCase()})`

  const fieldPrice = (field) => {
    const offPeakPrice = parseInt(field.offPeakPrice)
    const peakPrice = parseInt(field.peakPrice)

    if (!offPeakPrice || !peakPrice) {
      const price = offPeakPrice || peakPrice
      return <span><b>{`$${price}/hr${currencyName}`}</b></span>
    } else {
      return [
        <span key='off'>Off-peak<b>{` $${offPeakPrice}/hr${currencyName}`}</b></span>,
        <span key='on'>{`On-peak $${peakPrice}/hr${currencyName}`}</span>
      ]
    }
  }

  const fieldSelector = (size, fields) => {
    const selected = size == selectedSize
    const selectedClass = selected ? ' selected' : ''
    const fieldSizeLabel = `${size}v${size}`
  
    return <div className={'fields__selector' + selectedClass} key={size} onClick={() => props.onSelectSize(size)}>
      <div className='radio-input'>
        <div className={'radio-button' + selectedClass}></div>
        <b>{fieldSizeLabel}</b>
      </div>
      <div className='fields__selector__price'>
        {fieldPrice(fields[0])}
      </div>
    </div>
  }

  return <div className='fields'>
    <SectionHeader title='SELECT FIELD SIZE' />
    { step == 'field' && Object.keys(fieldSizes).map(size => fieldSelector(size, fieldSizes[size])) }
    { step == 'field' && 
      <div className='navigation-buttons desktop-only'>
        <button className='btn btn-next' onClick={props.onNextStep}>Next</button>
      </div>
    }
  </div>
}

FieldSizeSection.propTypes = {
  fieldSizes: PropTypes.object.isRequired,
  selectedSize: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  step: PropTypes.string.isRequired,
  onSelectSize: PropTypes.func.isRequired,
  onNextStep: PropTypes.func.isRequired,
}

export default FieldSizeSection
